/**
 * Drapeau d'activation de l'éditeur de schéma (F2-Forms-1c).
 *
 * L'éditeur de sections/champs et sa route `/formulaires/:id/versions/:versionId/edit`
 * sont livrés en **1c-ii**. En 1c-i la route N'EST PAS montée : le CTA « Modifier
 * le brouillon » ne doit donc jamais être un lien mort (décision PO §10).
 *
 * Contrat : la page détail ne rend le CTA actif QUE si `EDITOR_ROUTE_ENABLED`
 * est `true`. 1c-ii bascule ce drapeau à `true` **dans le même commit** qui
 * monte la route — jamais avant. Ainsi le CTA et la route arrivent ensemble.
 */
export const EDITOR_ROUTE_ENABLED = true;

export function formVersionEditorPath(templateId: string, versionId: string): string {
  return `/formulaires/${templateId}/versions/${versionId}/edit`;
}

/**
 * Route de remplissage conseiller (F2-Forms-1d-ii). Le CTA « Remplir » de la
 * fiche détail y navigue vers la **dernière version publiée** ; la page offre un
 * sélecteur pour choisir une ancienne version publiée (re-navigation par `:versionId`).
 * Livrée dans le même commit que la route montée dans App.tsx (jamais de lien mort).
 */
export function formFillPath(templateId: string, versionId: string): string {
  return `/formulaires/${templateId}/versions/${versionId}/remplir`;
}
